/** aria-describedby value for an input rendered inside `Field` (help and error ids). */
export function describedBy(id: string, hasHelp: boolean, hasErrors: boolean): string | undefined {
  const ids = [hasHelp ? `${id}-help` : null, hasErrors ? `${id}-error` : null].filter(Boolean);
  return ids.length ? ids.join(' ') : undefined;
}
